import React from 'react'

export function PassageGroupAnswerForm({ q, answer, onChange }) {
  const passage = q.payload?.passage || ''
  const embedded = Array.isArray(q.payload?.questions) ? q.payload.questions : []
  const subAnswers = (answer && answer.subAnswers) || {}

  function updateSubAnswer(index, innerAnswer) {
    const key = String(index)
    onChange(q, {
      subAnswers: {
        ...subAnswers,
        [key]: innerAnswer,
      },
    })
  }

  function renderEmbeddedBody(eq, idx) {
    const sub = subAnswers[String(idx)]
    const type = eq.type_key

    if (type === 'mcq') {
      const choices = Array.isArray(eq.payload?.choices) ? eq.payload.choices : []
      const selectedIndex = typeof sub?.selectedIndex === 'number' ? sub.selectedIndex : null
      return (
        <div style={{ display: 'grid', gap: 8 }}>
          {choices.map((c, cIdx) => (
            <label
              key={cIdx}
              style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}
            >
              <input
                type="radio"
                checked={selectedIndex === cIdx}
                onChange={() => updateSubAnswer(idx, { selectedIndex: cIdx })}
              />
              <span>{c || `خيار ${cIdx + 1}`}</span>
            </label>
          ))}
        </div>
      )
    }

    if (type === 'true_false') {
      const statements = Array.isArray(eq.payload?.statements) ? eq.payload.statements : []
      const ansStatements = Array.isArray(sub?.statements) ? sub.statements : []

      return (
        <div style={{ display: 'grid', gap: 8 }}>
          {statements.map((s, sIdx) => {
            const val = typeof ansStatements[sIdx]?.value === 'boolean' ? ansStatements[sIdx].value : null
            return (
              <div key={sIdx} style={{ display: 'grid', gap: 4 }}>
                <div style={{ fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                  {s?.text || ''}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
                    <input
                      type="radio"
                      checked={val === true}
                      onChange={() => {
                        const next = [...ansStatements]
                        next[sIdx] = { ...(next[sIdx] || {}), value: true }
                        updateSubAnswer(idx, { statements: next })
                      }}
                    />
                    <span>صحيح</span>
                  </label>
                  <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
                    <input
                      type="radio"
                      checked={val === false}
                      onChange={() => {
                        const next = [...ansStatements]
                        next[sIdx] = { ...(next[sIdx] || {}), value: false }
                        updateSubAnswer(idx, { statements: next })
                      }}
                    />
                    <span>خطأ</span>
                  </label>
                </div>
              </div>
            )
          })}
        </div>
      )
    }

    if (type === 'fill_blank') {
      const lines = Array.isArray(eq.payload?.lines) ? eq.payload.lines : []
      const lineAnswers = Array.isArray(sub?.lines) ? sub.lines : []
      return (
        <div style={{ display: 'grid', gap: 8 }}>
          {lines.map((l, lineIdx) => {
            const prev = lineAnswers[lineIdx] || { value: '' }
            return (
              <div key={lineIdx} style={{ display: 'grid', gap: 4 }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                  <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{lineIdx + 1}-</div>
                  <div style={{ fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
                    {l?.text || ''}
                  </div>
                </div>
                <input
                  value={prev.value || ''}
                  onChange={e => {
                    const next = [...lineAnswers]
                    next[lineIdx] = { value: e.target.value }
                    updateSubAnswer(idx, { lines: next })
                  }}
                  onMouseDown={e => e.stopPropagation()}
                  style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e5e7eb' }}
                />
              </div>
            )
          })}
        </div>
      )
    }

    if (type === 'definition') {
      const items = Array.isArray(eq.payload?.items) ? eq.payload.items : []
      const ansItems = Array.isArray(sub?.items) ? sub.items : []
      return (
        <div style={{ display: 'grid', gap: 10 }}>
          {items.map((it, dIdx) => {
            const prev = ansItems[dIdx] || { text: '' }
            return (
              <div key={dIdx} style={{ display: 'grid', gap: 6 }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                  <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{dIdx + 1}-</div>
                  <div style={{ color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6, flex: 1 }}>
                    {it?.term || '—'}
                  </div>
                </div>
                <textarea
                  defaultValue={prev.text || ''}
                  onBlur={e => {
                    const next = [...ansItems]
                    next[dIdx] = { text: e.target.value }
                    updateSubAnswer(idx, { items: next })
                  }}
                  style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: 80, resize: 'vertical' }}
                />
              </div>
            )
          })}
        </div>
      )
    }

    if (type === 'explanation') {
      const parts = Array.isArray(eq.payload?.parts) ? eq.payload.parts : []
      const ansParts = Array.isArray(sub?.parts) ? sub.parts : []
      return (
        <div style={{ display: 'grid', gap: 10 }}>
          {parts.map((p, eIdx) => {
            const prev = ansParts[eIdx] || { text: '' }
            return (
              <div key={eIdx} style={{ display: 'grid', gap: 6 }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                  <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{eIdx + 1}-</div>
                  <div style={{ color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6, flex: 1 }}>
                    {p?.prompt || '—'}
                  </div>
                </div>
                <textarea
                  defaultValue={prev.text || ''}
                  onBlur={e => {
                    const next = [...ansParts]
                    next[eIdx] = { text: e.target.value }
                    updateSubAnswer(idx, { parts: next })
                  }}
                  style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: 80, resize: 'vertical' }}
                />
              </div>
            )
          })}
        </div>
      )
    }

    // Fallback simple text for any other embedded type
    const generic = typeof sub?.value === 'string' ? sub.value : ''
    return (
      <textarea
        value={generic}
        onChange={e => updateSubAnswer(idx, { value: e.target.value })}
        style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: 80, resize: 'vertical' }}
      />
    )
  }

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {passage && (
        <div
          style={{
            padding: 10,
            borderRadius: 10,
            background: '#f9fafb',
            border: '1px solid #e5e7eb',
            fontSize: 13,
            lineHeight: 1.8,
          }}
        >
          {passage}
        </div>
      )}
      {embedded.map((eq, idx) => (
        <div
          key={eq.id || idx}
          style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 10, display: 'grid', gap: 6 }}
        >
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            {idx + 1}
            .
            {' '}
            {eq.prompt || 'بدون نص'}
          </div>
          <div>{renderEmbeddedBody(eq, idx)}</div>
        </div>
      ))}
    </div>
  )
}
